/**
 * @flow
 * @relayHash bb8da5134f258585498256db58467021
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type CashTransactionList_viewer$ref = any;
export type CashTransactionListQueryVariables = {|
  first?: ?number,
  offset?: ?number,
  transType?: ?string,
  search?: ?string,
  reportDate?: ?any,
  transactionDate?: ?any,
  symbol?: ?string,
  currency?: ?string,
  ibConId?: ?number,
  processedAt_Isnull?: ?boolean,
  ignored?: ?boolean,
  transTypeIn?: ?$ReadOnlyArray<?string>,
|};
export type CashTransactionListQueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: CashTransactionList_viewer$ref
  |}
|};
export type CashTransactionListQuery = {|
  variables: CashTransactionListQueryVariables,
  response: CashTransactionListQueryResponse,
|};
*/


/*
query CashTransactionListQuery(
  $first: Int
  $offset: Int
  $transType: String
  $search: String
  $reportDate: Date
  $transactionDate: Date
  $symbol: String
  $currency: String
  $ibConId: Int
  $processedAt_Isnull: Boolean
  $ignored: Boolean
  $transTypeIn: [String]
) {
  viewer {
    ...CashTransactionList_viewer_2lxReb
    id
  }
}

fragment CashTransactionList_viewer_2lxReb on Query {
  ibCashTransactions(first: $first, offset: $offset, transType: $transType, transactionDate: $transactionDate, search: $search, reportDate: $reportDate, symbol: $symbol, currency: $currency, ibConId: $ibConId, processedAt_Isnull: $processedAt_Isnull, ignored: $ignored, transTypeIn: $transTypeIn) {
    edges {
      node {
        id
        processedAt
        processedBy {
          username
          fullName
          id
        }
        group {
          id
          description
        }
        ignored
        ibConId
        currency
        description
        isin
        symbol
        transactionDate
        reportDate
        transactionId
        transType
        fxRateToBase
        assetCategory
        amount
        notes {
          id
        }
        contract {
          id
          ibConId
          currency
          symbol
        }
        brokeractivityPtr {
          group {
            id
            description
          }
          brokeractivitytransactionSet {
            edges {
              node {
                id
                account {
                  id
                  name
                }
                brokeractivitytransactioncontractdeltaSet {
                  edges {
                    node {
                      portfolio {
                        id
                      }
                      contract {
                        id
                        symbol
                      }
                      quantity
                      id
                    }
                  }
                }
                brokeractivitytransactioncashdeltaSet {
                  edges {
                    node {
                      currency
                      quantity
                      id
                    }
                  }
                }
              }
            }
          }
          id
          responsiblecontract {
            id
            contract {
              id
              name
              ibConId
              symbol
              currency
              exchange {
                name
                symbol
                id
              }
            }
          }
        }
      }
    }
    count
    pageInfo {
      endCursor
      startCursor
      hasNextPage
      hasPreviousPage
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "first",
    "type": "Int",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "offset",
    "type": "Int",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "transType",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "search",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "reportDate",
    "type": "Date",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "transactionDate",
    "type": "Date",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "symbol",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "currency",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "ibConId",
    "type": "Int",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "processedAt_Isnull",
    "type": "Boolean",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "ignored",
    "type": "Boolean",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "transTypeIn",
    "type": "[String]",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "currency",
    "variableName": "currency"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "ibConId",
    "variableName": "ibConId"
  },
  {
    "kind": "Variable",
    "name": "ignored",
    "variableName": "ignored"
  },
  {
    "kind": "Variable",
    "name": "offset",
    "variableName": "offset"
  },
  {
    "kind": "Variable",
    "name": "processedAt_Isnull",
    "variableName": "processedAt_Isnull"
  },
  {
    "kind": "Variable",
    "name": "reportDate",
    "variableName": "reportDate"
  },
  {
    "kind": "Variable",
    "name": "search",
    "variableName": "search"
  },
  {
    "kind": "Variable",
    "name": "symbol",
    "variableName": "symbol"
  },
  {
    "kind": "Variable",
    "name": "transType",
    "variableName": "transType"
  },
  {
    "kind": "Variable",
    "name": "transTypeIn",
    "variableName": "transTypeIn"
  },
  {
    "kind": "Variable",
    "name": "transactionDate",
    "variableName": "transactionDate"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "description",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "group",
  "storageKey": null,
  "args": null,
  "concreteType": "BrokerActivityGroupNode",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v3/*: any*/)
  ]
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "ibConId",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "currency",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "symbol",
  "args": null,
  "storageKey": null
},
v8 = [
  (v2/*: any*/)
],
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v10 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "quantity",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "CashTransactionListQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Query",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "CashTransactionList_viewer",
            "args": (v1/*: any*/)
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "CashTransactionListQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Query",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "ibCashTransactions",
            "storageKey": null,
            "args": (v1/*: any*/),
            "concreteType": "IBCashTransactionNodeConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "IBCashTransactionNodeEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "IBCashTransactionNode",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "processedAt",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "processedBy",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "UserNode",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "username",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "fullName",
                            "args": null,
                            "storageKey": null
                          },
                          (v2/*: any*/)
                        ]
                      },
                      (v4/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "ignored",
                        "args": null,
                        "storageKey": null
                      },
                      (v5/*: any*/),
                      (v6/*: any*/),
                      (v3/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "isin",
                        "args": null,
                        "storageKey": null
                      },
                      (v7/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "transactionDate",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "reportDate",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "transactionId",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "transType",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "fxRateToBase",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "assetCategory",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "amount",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "notes",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "NotesNode",
                        "plural": false,
                        "selections": (v8/*: any*/)
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "contract",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ContractNode",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          (v5/*: any*/),
                          (v6/*: any*/),
                          (v7/*: any*/)
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "brokeractivityPtr",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "BrokerActivityNode",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "brokeractivitytransactionSet",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "BrokerActivityTransactionNodeConnection",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "edges",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "BrokerActivityTransactionNodeEdge",
                                "plural": true,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "node",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "BrokerActivityTransactionNode",
                                    "plural": false,
                                    "selections": [
                                      (v2/*: any*/),
                                      {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "account",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "AccountNode",
                                        "plural": false,
                                        "selections": [
                                          (v2/*: any*/),
                                          (v9/*: any*/)
                                        ]
                                      },
                                      {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "brokeractivitytransactioncontractdeltaSet",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "BrokerActivityTransactionContractDeltaNodeConnection",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "edges",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "BrokerActivityTransactionContractDeltaNodeEdge",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "kind": "LinkedField",
                                                "alias": null,
                                                "name": "node",
                                                "storageKey": null,
                                                "args": null,
                                                "concreteType": "BrokerActivityTransactionContractDeltaNode",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "portfolio",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "PortfolioNode",
                                                    "plural": false,
                                                    "selections": (v8/*: any*/)
                                                  },
                                                  {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "contract",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "ContractNode",
                                                    "plural": false,
                                                    "selections": [
                                                      (v2/*: any*/),
                                                      (v7/*: any*/)
                                                    ]
                                                  },
                                                  (v10/*: any*/),
                                                  (v2/*: any*/)
                                                ]
                                              }
                                            ]
                                          }
                                        ]
                                      },
                                      {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "brokeractivitytransactioncashdeltaSet",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "BrokerActivityTransactionCashDeltaNodeConnection",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "edges",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "BrokerActivityTransactionCashDeltaNodeEdge",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "kind": "LinkedField",
                                                "alias": null,
                                                "name": "node",
                                                "storageKey": null,
                                                "args": null,
                                                "concreteType": "BrokerActivityTransactionCashDeltaNode",
                                                "plural": false,
                                                "selections": [
                                                  (v6/*: any*/),
                                                  (v10/*: any*/),
                                                  (v2/*: any*/)
                                                ]
                                              }
                                            ]
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          },
                          (v2/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "responsiblecontract",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "ResponsibleContractNode",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "contract",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "ContractNode",
                                "plural": false,
                                "selections": [
                                  (v2/*: any*/),
                                  (v9/*: any*/),
                                  (v5/*: any*/),
                                  (v7/*: any*/),
                                  (v6/*: any*/),
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "exchange",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "ExchangeNode",
                                    "plural": false,
                                    "selections": [
                                      (v9/*: any*/),
                                      (v7/*: any*/),
                                      (v2/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "count",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "pageInfo",
                "storageKey": null,
                "args": null,
                "concreteType": "PageInfo",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "endCursor",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "startCursor",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "hasNextPage",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "hasPreviousPage",
                    "args": null,
                    "storageKey": null
                  }
                ]
              }
            ]
          },
          (v2/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "CashTransactionListQuery",
    "id": null,
    "text": "query CashTransactionListQuery(\n  $first: Int\n  $offset: Int\n  $transType: String\n  $search: String\n  $reportDate: Date\n  $transactionDate: Date\n  $symbol: String\n  $currency: String\n  $ibConId: Int\n  $processedAt_Isnull: Boolean\n  $ignored: Boolean\n  $transTypeIn: [String]\n) {\n  viewer {\n    ...CashTransactionList_viewer_2lxReb\n    id\n  }\n}\n\nfragment CashTransactionList_viewer_2lxReb on Query {\n  ibCashTransactions(first: $first, offset: $offset, transType: $transType, transactionDate: $transactionDate, search: $search, reportDate: $reportDate, symbol: $symbol, currency: $currency, ibConId: $ibConId, processedAt_Isnull: $processedAt_Isnull, ignored: $ignored, transTypeIn: $transTypeIn) {\n    edges {\n      node {\n        id\n        processedAt\n        processedBy {\n          username\n          fullName\n          id\n        }\n        group {\n          id\n          description\n        }\n        ignored\n        ibConId\n        currency\n        description\n        isin\n        symbol\n        transactionDate\n        reportDate\n        transactionId\n        transType\n        fxRateToBase\n        assetCategory\n        amount\n        notes {\n          id\n        }\n        contract {\n          id\n          ibConId\n          currency\n          symbol\n        }\n        brokeractivityPtr {\n          group {\n            id\n            description\n          }\n          brokeractivitytransactionSet {\n            edges {\n              node {\n                id\n                account {\n                  id\n                  name\n                }\n                brokeractivitytransactioncontractdeltaSet {\n                  edges {\n                    node {\n                      portfolio {\n                        id\n                      }\n                      contract {\n                        id\n                        symbol\n                      }\n                      quantity\n                      id\n                    }\n                  }\n                }\n                brokeractivitytransactioncashdeltaSet {\n                  edges {\n                    node {\n                      currency\n                      quantity\n                      id\n                    }\n                  }\n                }\n              }\n            }\n          }\n          id\n          responsiblecontract {\n            id\n            contract {\n              id\n              name\n              ibConId\n              symbol\n              currency\n              exchange {\n                name\n                symbol\n                id\n              }\n            }\n          }\n        }\n      }\n    }\n    count\n    pageInfo {\n      endCursor\n      startCursor\n      hasNextPage\n      hasPreviousPage\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '387a988154c11b7087e390a2cca3b805';
module.exports = node;
